module.exports = __webpack_public_path__ + "img/9788952754820.4fd7ee46.jpg";